import type { Nullable } from '@library/types'
import { chunkArray } from '@library/utils'
import { select } from 'd3'
import { useEffect } from 'react'

import { useLegendContext } from './context'
import { createGradientDefs, getPalette, isPaletteReversed } from './helpers'

export const useGradientDefs = (
  id: string,
  containerElement: Nullable<SVGGElement>,
  palette?: Nullable<number[]>,
) => {
  const { attribute, isHorizontal } = useLegendContext()

  useEffect(() => {
    const selectedPalette = palette ?? getPalette(attribute)
    if (!selectedPalette) return

    const container = select(containerElement)
    const chunkedPalette = chunkArray(selectedPalette, 4)
    if (!isPaletteReversed(attribute)) {
      chunkedPalette.reverse()
    }

    const defs = createGradientDefs(container, id, chunkedPalette, isHorizontal)

    return () => {
      defs.remove()
    }
  }, [containerElement, attribute, palette, id, isHorizontal])
}
